import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppGuard } from './app.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./base/base.module').then((m) => m.BaseModule),
        canActivate: [AppGuard],
    },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true, initialNavigation: 'disabled' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
